import './styles.scss';
import React, { ReactNode } from 'react';
import { CollapsibleToolbarComponent } from './collapsibleToolbarComponent';
import TsrSvgIcon, { Icon } from '../../assets/icons';

interface CollapsibleToolbarProps {
    isOpen: boolean;
    position: 'bottom' | 'right' | 'left';
    className?: string;
    contentClassName?: string;
    children?: ReactNode;
    toggle: () => void;
    onTransitionStart?: () => void;
    onTransitionEnd?: (e: React.TransitionEvent<HTMLDivElement>) => void;
}
export class CollapsibleToolbar extends React.Component<CollapsibleToolbarProps> {
    private iconClosed = () => {
        switch (this.props.position) {
            case 'bottom':
                return <TsrSvgIcon icon={Icon.ArrowUp} />;
            case 'right':
                return <TsrSvgIcon icon={Icon.ArrowPrevious} />;
            case 'left':
                return <TsrSvgIcon icon={Icon.ArrowNext} />;
            default:
                return <TsrSvgIcon icon={Icon.ArrowPrevious} />;
        }
    };
    private iconOpened = () => {
        switch (this.props.position) {
            case 'bottom':
                return <TsrSvgIcon icon={Icon.ArrowDown} />;
            case 'right':
                return <TsrSvgIcon icon={Icon.ArrowNext} />;
            case 'left':
                return <TsrSvgIcon icon={Icon.ArrowPrevious} />;
            default:
                return <TsrSvgIcon icon={Icon.ArrowNext} />;
        }
    };

    public render(): JSX.Element {
        return (
            <CollapsibleToolbarComponent
                isOpen={this.props.isOpen}
                position={this.props.position}
                className={this.props.className}
                contentClassName={this.props.contentClassName}
                collapseIcon={this.props.isOpen ? this.iconOpened() : this.iconClosed()}
                toggle={() => this.handleToggle()}
                onTransitionStart={() => this.props.onTransitionStart && this.props.onTransitionStart()}
                onTransitionEnd={e => this.props.onTransitionEnd && this.props.onTransitionEnd(e)}
            >
                {this.props.children}
            </CollapsibleToolbarComponent>
        );
    }
    private handleToggle(): void {
        this.props.toggle();
    }
}
